import React from 'react';
import { OPERATION_TYPES } from '../../services/deliveryService';

const tabConfig = {
  Create: { label: 'Create' },
  Scheduled: { label: 'Scheduled' },
  Complete: { label: 'Complete' },
  Failed: { label: 'Failed' },
  SAP_SO: { label: 'Standard' },
  Exchange: { label: 'Exchanges' },
  Pickup: { label: 'Pickups' },
};

export default function FilterTabs({ activeOperation, onOperationChange, allowedOperations }) {
  const visibleTypes = allowedOperations
    ? OPERATION_TYPES.filter((op) => allowedOperations.includes(op))
    : OPERATION_TYPES;

  return (
    <div className="inline-flex gap-1 p-1 bg-locate2-bg-light border border-locate2-border-light rounded-lg">
      {visibleTypes.map((op) => {
        const { label } = tabConfig[op] || { label: op };
        const isActive = activeOperation === op;
        return (
          <button
            key={op}
            onClick={() => onOperationChange(op)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-all whitespace-nowrap ${
              isActive
                ? 'bg-locate2-primary text-white shadow-sm'
                : 'text-locate2-light-gray hover:bg-white hover:text-locate2-medium-gray'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
